import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, IconButton, Paper, useTheme, Typography, TextField, Autocomplete, ThemeProvider, CssBaseline, Backdrop, CircularProgress } from "@mui/material";
import { Add, Cancel, Delete, Edit, Save, Stop, Visibility } from "@mui/icons-material";
import { CREATE_TESTJOB_URL, DELETE_TESTJOB_URL, GET_ALL_PODS_URL, GET_ALL_TESTSUITES_BY_TENANTID_URL, GET_TENANT_USING_USERID_COMPANYID_URL, GET_TESTJOBS_USING_USERID_COMPANYID_URL, UPDATE_TESTJOB_URL } from "envConfig";
import { Logger } from "utils/Logger";
import { Pod, Tenant, TestJob as TestJob_Structure, TestSuite } from "../../Interfaces/AutomateTest";
import { useSelector } from "react-redux";
import { RootState } from "state/store";

export const TestJob: React.FC = () => {
    const theme = useTheme();
    const { tenantId } = useParams<{ tenantId: string }>();
    const [tenantTestJobs, setTenantTestJobs] = useState<TestJob_Structure[]>([]);
    // const [testJobs, setTestJobs] = useState<TestJob_Structure[]>([]);
    const [editMode, setEditMode] = useState<string | null>(null);
    const [testJobEditedRow, setTestJobEditedRow] = useState<Partial<TestJob_Structure>>({});
    const [newTestJobRow, setnewTestJobRow] = useState<TestJob_Structure | null>(null);
    const [nameError, setNameError] = useState(false);
    const [testSuiteError, setTestSuiteError] = useState(false);
    const [pods, setPods] = useState<Pod[]>([]);
    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [testSuites, setTestSuites] = useState<TestSuite[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const jobTypes = ["CRON", "ADHOC"];

    const navigate = useNavigate();

    const user = useSelector((state: RootState) => state.authentication.user);

  // Fetch TestJobs from the API
    const fetchTestJobs = async () => {
      setLoading(true);
      try {
        const response = await fetch(GET_TESTJOBS_USING_USERID_COMPANYID_URL+`/?userId=${user._id}&companyId=${user.companyId}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
        });
        Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchTestJobs(): response  " ,JSON.stringify(response, null, 2));

        if (!response.ok) {
            setLoading(false);
            Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchTestJobs(): issue while getting TestJob, response is " , response.statusText);
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        if (Array.isArray(data.data)) {
          Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchTestJobs():  TestJobs are: " , JSON.stringify(data.data, null, 2));
          const sortedTestJobs = data.data.sort((a: { updatedAt: string | number | Date; }, b: { updatedAt: string | number | Date; }) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
          setTenantTestJobs(sortedTestJobs);
            setLoading(false);
        } else {
            Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchTestJobs(): ", "Unexpected API response format: " + JSON.stringify(data.data, null, 2));
            setTenantTestJobs([]);
            setLoading(false);
        }
      } catch (error) {
        Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchTestJobs(): ", "Failed to fetch testJobs: "+ error);
        setTenantTestJobs([]);
        setLoading(false);
      }
    };

    useEffect(() => {
        fetchTestJobs();
    }, []);

const handleAddNewTestJobRow = () => {
    const newTestJob: TestJob_Structure = {
      _id: "",
      name: "",
      description: "",
      cronExp: "",
      type: "",
      userId: user._id,
      companyId: user.companyId,
      tenantId: "",
      testSuiteId: "",
      testSuiteVersion: 0,
      podId: "",
      browser: "Chrome",
      status: "Pending",
      Mode: "enabled",
      takeScreenshots: false,
      takeScreenshotsOnFail: false,
      recordVideo: false,
      recordVideoOnFail: false,
    };
    setnewTestJobRow(newTestJob);
  };

  const handleTestJobEdit = (_id: string) => {
    setEditMode(_id);
    const testJob = tenantTestJobs.find((testJob) => testJob._id === _id);
    if (testJob) setTestJobEditedRow(testJob);
  };

  const handleCancelEdit = () => {
    // setnewDataSetRow(null);
    setnewTestJobRow(null);
    setEditMode(null);
    setTestJobEditedRow({});
  };

  const handleCreateNewTestJob = async () => {
    Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : handleCreateNewTestJob(): ", "Creating new TestJob: "+ JSON.stringify(newTestJobRow, null, 2));
      try {
        if (!newTestJobRow?.name) {
          setNameError(true);
          return;
        }else if(!newTestJobRow?.testSuiteId){
          setTestSuiteError(true);
          return;
        }
        setLoading(true);
        const response = await fetch(CREATE_TESTJOB_URL, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newTestJobRow),
        });

        if (!response.ok) {
          setLoading(false);
          throw new Error(`Error: ${response.status}`);
        }
        await fetchTestJobs();
        Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : handleCreateNewTestJob(): ", "Failed to save new TestJob: "+ JSON.stringify(setTenantTestJobs, null, 2));

        setnewTestJobRow(null);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : handleCreateNewTestJob(): ", "Failed to save new TestJob: "+ error);
      }
  };

  const handleUpdateTestJob = async (_id:string) => {
    setLoading(true);
    try {
      const response = await fetch(`${UPDATE_TESTJOB_URL}/${_id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(testJobEditedRow),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error(`Error: ${response.statusText}`);
      }

      setTenantTestJobs((prev) =>
        prev.map((testJob) =>
          testJob._id === testJobEditedRow._id ? { ...testJob, ...testJobEditedRow } : testJob
        )
      );
      setEditMode(null);
      setTestJobEditedRow({});
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : handleSave(): ", "Failed to save testJob:" + error);
    }
  };

  const handleTestJobInputChange = (_id: string, field: keyof TestJob_Structure, value: string) => {
    if (_id === "" && newTestJobRow) {
      setnewTestJobRow((prev) => prev ? { ...prev, [field]: value } : null);
      if (field === "name" && value) {
        setNameError(false);
      }
    } else if (editMode === _id) {
      setTestJobEditedRow((prev) => ({ ...prev, [field]: value }));
    } else {
      setTenantTestJobs((prev) =>
        prev.map((testJob) =>
          testJob._id === _id ? { ...testJob, [field]: value } : testJob
        )
      );
    }
  };

  const handleDeleteTestJob = async(_id: string) => {
    try {
      setLoading(true);
        const response = await fetch(DELETE_TESTJOB_URL+`/${_id}`, {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (!response.ok) {
          setLoading(false);
          throw new Error(`Error: ${response.status}`);
        }
        await fetchTestJobs();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : handleDeleteTestJob(): ", "Failed to delete testJob:"+ error);
      }
  };

  const fetchPods = async () => {
      try {
        setLoading(true);
        const response = await fetch(GET_ALL_PODS_URL, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
        });
        Logger.info("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchPods(): response  " ,JSON.stringify(response, null, 2));

        if (!response.ok) {
          setLoading(false);
            Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchPods(): issue while getting Pods, response is " , response.statusText);
          throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        if (Array.isArray(data.data)) {
          Logger.debug("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchPods():  Pods are: " , JSON.stringify(data.data, null, 2));
            setPods(data.data);
            setLoading(false);
        } else {
            Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchPods(): ", "Unexpected API response format: " + JSON.stringify(data.data, null, 2));
            setPods([]);
            setLoading(false);
        }
      } catch (error) {
        Logger.error("st-ck-client/src/modules/AutomateTest/TestJob/TestJob.ts : fetchPods(): ", "Failed to fetch Pods: "+ error);
        setPods([]);
        setLoading(false);
      }
    };
  
  useEffect(() => {
    fetchPods();
  }, []);
  
  const fetchTenants = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${GET_TENANT_USING_USERID_COMPANYID_URL}/?userId=${user._id}&companyId=${user.companyId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        setLoading(false);
          Logger.error("st-ck-client/src/modules/AutomateTest/Tenant/Tenant.ts : fetchTenants(): issue while getting Tenant, response is " , response.statusText);
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      if (Array.isArray(data.data)) {
        setTenants(data.data);
        setLoading(false);
      } else {
          Logger.error("st-ck-client/src/modules/AutomateTest/Tenant/Tenant.ts : fetchTenants(): ", "Unexpected API response format: " + JSON.stringify(data.data, null, 2));
          setTenants([]);
          setLoading(false);
      }
    } catch (error) {
      Logger.error("st-ck-client/src/modules/AutomateTest/Tenant/Tenant.ts : fetchTenants(): ", "Failed to fetch tenants: "+ error);
      setTenants([]);
      setLoading(false);
    }
  };
  useEffect(() => {
      fetchTenants();
  }, []);

  const fetchTestSuites = async (SelectedTenantId: string) => {
    try {
      setLoading(true);
      const response = await fetch(GET_ALL_TESTSUITES_BY_TENANTID_URL+`/${SelectedTenantId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      if (Array.isArray(data.data)) {
          setTestSuites(data.data);
          setLoading(false);
          Logger.debug("st-ck-client/src/modules/AutomateTest/TestSuite/TestSuite.ts : fetchTestSuites(): ", "testSuites:"+ JSON.stringify(data.data, null, 2));
      } else {
        setTestSuites([]);
        setLoading(false);
        Logger.debug("st-ck-client/src/modules/AutomateTest/TestSuite/TestSuite.ts : fetchTestSuites(): Expected an array, received:", JSON.stringify(data.data));
      }

    } catch (error) {
        setTestSuites([]);
        setLoading(false);
        Logger.debug("st-ck-client/src/modules/AutomateTest/TestSuite/TestSuite.ts : fetchTestSuites(): ", "Failed to fetch testSuites:"+ error);
    }
  };
  useEffect(() => {
    const tenantIdToFetch = newTestJobRow?.tenantId || testJobEditedRow?.tenantId;
    if (tenantIdToFetch) {
      fetchTestSuites(tenantIdToFetch);
    } else {
      setTestSuites([]);
    }
  }, [newTestJobRow?.tenantId, testJobEditedRow?.tenantId]);
  


  return ( loading ?
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Backdrop
        sx={(theme) => ({ color: theme.palette.secondary.main, zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </ThemeProvider>
    :
    <Box pl={{ xs: 1.25, sm: 2.5 }} pt={1}  width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
        Execute Test Automation
      </Typography>
      <Box mb={2}>
        <Button variant="contained" sx={{ backgroundColor: theme.palette.primary.main }} startIcon={<Add />} onClick={handleAddNewTestJobRow}>
        New EXECUTION
        </Button>
        </Box>
      </Box>
      <TableContainer component={Paper}  sx={{ width: "100%", overflowX: "auto", display: "block" }}>
        <Table sx={{ tableLayout: "auto", "& td, & th": { maxWidth: "130px", width:"150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>NAME</TableCell>
              <TableCell>TANENT</TableCell>
              <TableCell>TESTSUITE</TableCell>
              <TableCell>POD</TableCell>
              <TableCell>Job Type</TableCell>
              <TableCell>CRON EXP.</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tenantTestJobs.map((testJob, index) => (
              <TableRow key={testJob._id}>
                <TableCell>{index}</TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <TextField size="small" label="Name"
                      value={testJobEditedRow.name || ""}
                      onChange={(e) => handleTestJobInputChange(testJob._id, "name", e.target.value)} error={nameError}
                      helperText={nameError ? "Job Name is required" : ""}
                    />
                  ) : (
                    testJob.name
                  )}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <Autocomplete size="small" options={tenants} getOptionLabel={(option) => option.name}
                      value={tenants.find((tenant) => tenant._id === testJobEditedRow?.tenantId) || null}
                      onChange={(_event, newValue) => // Changed event to _event
                      handleTestJobInputChange(testJob._id, "tenantId", newValue ? newValue._id : "")}
                      renderInput={(params) => (
                      <TextField {...params} label="Select Tenant" helperText={nameError ? "Tenant is required" : ""} />)}
                    />
                  ) : (
                    tenants.find((tenant) => tenant._id === testJob.tenantId)?.name || "N/A"
                  )}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                   <Autocomplete size="small" options={testSuites.filter((suite) => suite.status === "Published")} 
                      getOptionLabel={(option) => option.name}
                      value={testSuites.find((testSuite) => testSuite._id === testJobEditedRow?.testSuiteId) || null}
                      onChange={(_event, newValue) => // Changed event to _event
                      handleTestJobInputChange(testJob._id, "testSuiteId", newValue ? newValue._id : "")}
                      renderInput={(params) => (
                      <TextField {...params} label="Select TestSuite" helperText={testSuiteError ? "TestSuite is required" : ""} />)}
                      disabled={!testJob.tenantId}/>
                  ) : (
                    testSuites.find((testSuite) => testSuite._id === testJob.testSuiteId)?.name || "N/A")}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <TextField size="small" label="Pod"
                      value={testJobEditedRow.podId || ""}
                      onChange={(e) => handleTestJobInputChange(testJob._id, "podId", e.target.value)} error={nameError}
                      helperText={nameError ? "Pod Name is required" : ""}
                    />
                  ) : (
                    testJob.podId
                  )}
                </TableCell>
                <TableCell>
                {editMode === testJob._id ? (
                  <Autocomplete
                    size="small"
                    options={jobTypes}
                    value={testJobEditedRow?.type}
                    onChange={(_event, newValue) => handleTestJobInputChange(testJob._id, "type", newValue || "System")} // Changed event to _event
                    renderInput={(params) => <TextField {...params} label="Job Type" />}
                  />
                   ) : (
                    testJob.type
                )}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <TextField size="small" label="Cron Exp."
                      value={testJobEditedRow.cronExp || ""}
                      onChange={(e) => handleTestJobInputChange(testJob._id, "cronExp", e.target.value)}
                    />
                  ) : (
                    testJob.cronExp
                  )}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <TextField size="small" label="Status"
                      value={testJobEditedRow.status || ""}
                      onChange={(e) => handleTestJobInputChange(testJob._id, "status", e.target.value)} error={nameError}
                      helperText={nameError ? "Status is required" : ""}
                    />
                  ) : (
                    testJob.status
                  )}
                </TableCell>
                <TableCell>
                  {editMode === testJob._id ? (
                    <>
                      <IconButton onClick={()=>handleUpdateTestJob(testJob._id)}>
                        <Save />
                      </IconButton>
                      <IconButton onClick={handleCancelEdit}>
                        <Cancel />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton onClick={() => navigate(`/tenant/${tenantId}/testJob/${testJob._id}`)}>
                        <Visibility />
                      </IconButton>
                      <IconButton onClick={() => handleTestJobEdit(testJob._id)}>
                        <Edit />
                      </IconButton>
                      <IconButton>
                        <Stop />
                      </IconButton>
                      <IconButton onClick={() => handleDeleteTestJob(testJob._id)}>
                        <Delete />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
              {newTestJobRow && (
              <TableRow>
                <TableCell>New</TableCell>
                <TableCell>
                  <TextField size="small" label="Name"
                    value={newTestJobRow.name}
                    onChange={(e) => handleTestJobInputChange("", "name", e.target.value)} error={nameError}
                    helperText={nameError ? "Name is required" : ""}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete size="small" options={tenants} getOptionLabel={(option) => option.name}
                    value={tenants.find((tenant) => tenant._id === newTestJobRow?.tenantId) || null}
                    onChange={(_event, newValue) => {handleTestJobInputChange("", "tenantId", newValue ? newValue._id : "");}}
                    renderInput={(params) => <TextField {...params} label="Select Tenant" helperText={nameError ? "Tenant is required" : ""}/> }
                    />
                </TableCell>
                <TableCell>
                  <Autocomplete size="small" options={testSuites.filter((suite) => suite.status === "Published" && 
                    (tenantTestJobs ? tenantTestJobs.every((testJob) => testJob.testSuiteId !== suite._id) : true))} 
                    getOptionLabel={(option) => option.name}
                    value={testSuites.find((testSuite) => testSuite._id === newTestJobRow?.testSuiteId) || null}
                    onChange={(_event, newValue) => handleTestJobInputChange("", "testSuiteId", newValue ? newValue._id : "")}
                    renderInput={(params) => (
                  <TextField {...params} label="Select TestSuite"  error={testSuiteError} helperText={testSuiteError ? "TestSuite is required" : ""} />)}
                     disabled={!newTestJobRow?.tenantId}/>
                </TableCell>
                <TableCell>
                  <Autocomplete size="small" options={pods} getOptionLabel={(option) => option.name}
                    value={pods.find((pod) => pod._id === newTestJobRow?.podId) || null}
                    onChange={(_event, newValue) => {handleTestJobInputChange("", "podId", newValue ? newValue._id : "");}}
                    renderInput={(params) => <TextField {...params} label="Select Pod" />}
                    />
                </TableCell>
                <TableCell>
                  <Autocomplete size="small" options={jobTypes} value={newTestJobRow?.type}
                    onChange={(_event, newValue) => handleTestJobInputChange("", "type", newValue || "System")}
                    renderInput={(params) => <TextField {...params} label="Job Type" />}
                  />
                </TableCell>
                <TableCell>
                <TextField size="small" label="Cron Exp." value={newTestJobRow.cronExp}
                    onChange={(e) => handleTestJobInputChange("", "cronExp", e.target.value)}
                    error={newTestJobRow.type === "CRON" && !newTestJobRow.cronExp} // Error if empty
                    helperText={newTestJobRow.type === "CRON" && !newTestJobRow.cronExp ? "Cron expression is required" : ""}
                    disabled={newTestJobRow.type === "ADHOC"} // Disable if type is ADHOK
                />
                </TableCell>
                <TableCell>
                  <TextField size="small" label="Status"
                    value={newTestJobRow.status}
                    onChange={(e) => handleTestJobInputChange("", "status", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                <TableCell>
                  <IconButton onClick={handleCreateNewTestJob}>
                    <Save />
                  </IconButton>
                  <IconButton onClick={handleCancelEdit}>
                    <Cancel />
                  </IconButton>
                </TableCell>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Dialog open={podDialogOpen} onClose={() => setPodDialogOpen(false)}>
  <DialogTitle>Select a Pod</DialogTitle>
  <DialogContent>
    <List>
      {pods.map((pod) => (
        <ListItem key={pod._id}>
          <ListItemButton onClick={() => { setSelectedPod(pod._id); setPodDialogOpen(false); }}>
            <ListItemText primary={pod.name} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setPodDialogOpen(false)}>Cancel</Button>
  </DialogActions>
</Dialog> */}
    </Box>
  );
};
